import { render } from "./UserLabelListFilters.vue?vue&type=template&id=6674bb75&ts=true"
import script from "./UserLabelListFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelListFilters.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user-label/components/UserLabelListFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6674bb75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6674bb75', __exports__)) {
    api.reload('6674bb75', __exports__)
  }
  
  module.hot.accept("./UserLabelListFilters.vue?vue&type=template&id=6674bb75&ts=true", () => {
    api.rerender('6674bb75', render)
  })

}


export default __exports__